import { CartItemStateModel, ClientStateModel } from './cart.state';

export class GetCart {
  static readonly type = '[Cart] Get Cart';
  constructor() {}
}

export class AddToCart {
  static readonly type = '[Cart] Add To Cart';
  constructor(public payload: CartItemStateModel) {}
}

export class DeleteCartItem {
  static readonly type = '[Cart] Delete Cart Item';
  constructor(public payload: number) {}
}

export class ClearCart {
  static readonly type = '[Cart] Clear Cart';
  constructor() {}
}

export class SetCart {
  static readonly type = '[Cart] Set Cart';
  constructor(public payload: any) {}
}

export class SetOverlappingStatus {
  static readonly type = '[Cart] Set Cart Overlapping Status';
  constructor(public payload: any) {}
}
export class SetCartAddress {
  static readonly type = '[Cart] Set Cart Address';
  constructor(public payload: any) {}
}

export class SetCartTaxRate {
  static readonly type = '[Cart] Set Cart Address';
  constructor(public payload: number) {}
}

export class SetCartSelectedClient {
  static readonly type = '[Cart] Set Cart Selected Client';
  constructor(public payload: ClientStateModel) {}
}
